import { createUseStyles } from 'react-jss'

export default createUseStyles({
  tag: {
    alignItems: 'center',
    backgroundColor: 'var(--tag__background__color)',
    color: 'var(--body__text__color)',
    display: 'inline-flex',
    fontSize: '0.75rem',
    height: '2rem',
    justifyContent: 'center',
    lineHeight: '1.5',
    paddingLeft: '0.75em',
    paddingRight: '0.75em',
    whiteSpace: 'nowrap',
    '& a': {
      color: 'var(--link__text__color)'
    }
  }
})
